import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "profile"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Perfil", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("input", {
  autocomplete: "off",
  type: "radio",
  name: "profile",
  id: "profile-register",
  checked: ""
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("input", {
  autocomplete: "off",
  type: "radio",
  name: "profile",
  id: "profile-password"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "tab" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "profile-register" }, "Cadastro"),
  /*#__PURE__*/_createElementVNode("label", { for: "profile-password" }, "Senha")
], -1)
const _hoisted_8 = { class: "register" }
const _hoisted_9 = { class: "photo" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", null, "Foto do usuário", -1)
const _hoisted_11 = {
  key: 0,
  class: "tooltip",
  for: "profile-photo"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<label class=\"tooltip\" for=\"profile-photo\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M13.2603 3.60022L5.05034 12.2902C4.74034 12.6202 4.44034 13.2702 4.38034 13.7202L4.01034 16.9602C3.88034 18.1302 4.72034 18.9302 5.88034 18.7302L9.10034 18.1802C9.55034 18.1002 10.1803 17.7702 10.4903 17.4302L18.7003 8.74022C20.1203 7.24022 20.7603 5.53022 18.5503 3.44022C16.3503 1.37022 14.6803 2.10022 13.2603 3.60022Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.8896 5.0498C12.3196 7.8098 14.5596 9.9198 17.3396 10.1998\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M3 22H21\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></label>", 1)
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M18.8504 9.14014L18.2004 19.2101C18.0904 20.7801 18.0004 22.0001 15.2104 22.0001H8.79039C6.00039 22.0001 5.91039 20.7801 5.80039 19.2101L5.15039 9.14014\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10.3301 16.5H13.6601\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9.5 12.5H14.5\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "Adicione uma foto de perfil para sua área de trabalho ficar ainda mais personalizada.", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nome"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "surname" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Sobrenome"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "E-mail"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_22 = { class: "password" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "new-password" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Crie uma nova senha"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_24 = ["type"]
const _hoisted_25 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("g", { id: "vuesax/linear/eye" }, [
  /*#__PURE__*/_createElementVNode("g", { id: "eye" }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector",
      d: "M15.58 11.9999C15.58 13.9799 13.98 15.5799 12 15.5799C10.02 15.5799 8.41998 13.9799 8.41998 11.9999C8.41998 10.0199 10.02 8.41992 12 8.41992C13.98 8.41992 15.58 10.0199 15.58 11.9999Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector_2",
      d: "M12 20.2702C15.53 20.2702 18.82 18.1902 21.11 14.5902C22.01 13.1802 22.01 10.8102 21.11 9.40021C18.82 5.80021 15.53 3.72021 12 3.72021C8.47003 3.72021 5.18003 5.80021 2.89003 9.40021C1.99003 10.8102 1.99003 13.1802 2.89003 14.5902C5.18003 18.1902 8.47003 20.2702 12 20.2702Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<path d=\"M14.5299 9.46992L9.46992 14.5299C8.81992 13.8799 8.41992 12.9899 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C12.9899 8.41992 13.8799 8.81992 14.5299 9.46992Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M17.8198 5.76998C16.0698 4.44998 14.0698 3.72998 11.9998 3.72998C8.46984 3.72998 5.17984 5.80998 2.88984 9.40998C1.98984 10.82 1.98984 13.19 2.88984 14.6C3.67984 15.84 4.59984 16.91 5.59984 17.77\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.41992 19.5299C9.55992 20.0099 10.7699 20.2699 11.9999 20.2699C15.5299 20.2699 18.8199 18.1899 21.1099 14.5899C22.0099 13.1799 22.0099 10.8099 21.1099 9.39993C20.7799 8.87993 20.4199 8.38993 20.0499 7.92993\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.5099 12.7C15.2499 14.11 14.0999 15.26 12.6899 15.52\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9.47 14.53L2 22\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M21.9998 2L14.5298 9.47\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path>", 6)
const _hoisted_35 = [
  _hoisted_29
]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { for: "repeat-new-password" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Repita a nova senha"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_37 = ["type"]
const _hoisted_38 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("g", { id: "vuesax/linear/eye" }, [
  /*#__PURE__*/_createElementVNode("g", { id: "eye" }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector",
      d: "M15.58 11.9999C15.58 13.9799 13.98 15.5799 12 15.5799C10.02 15.5799 8.41998 13.9799 8.41998 11.9999C8.41998 10.0199 10.02 8.41992 12 8.41992C13.98 8.41992 15.58 10.0199 15.58 11.9999Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector_2",
      d: "M12 20.2702C15.53 20.2702 18.82 18.1902 21.11 14.5902C22.01 13.1802 22.01 10.8102 21.11 9.40021C18.82 5.80021 15.53 3.72021 12 3.72021C8.47003 3.72021 5.18003 5.80021 2.89003 9.40021C1.99003 10.8102 1.99003 13.1802 2.89003 14.5902C5.18003 18.1902 8.47003 20.2702 12 20.2702Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_42 = /*#__PURE__*/_createStaticVNode("<path d=\"M14.5299 9.46992L9.46992 14.5299C8.81992 13.8799 8.41992 12.9899 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C12.9899 8.41992 13.8799 8.81992 14.5299 9.46992Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M17.8198 5.76998C16.0698 4.44998 14.0698 3.72998 11.9998 3.72998C8.46984 3.72998 5.17984 5.80998 2.88984 9.40998C1.98984 10.82 1.98984 13.19 2.88984 14.6C3.67984 15.84 4.59984 16.91 5.59984 17.77\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.41992 19.5299C9.55992 20.0099 10.7699 20.2699 11.9999 20.2699C15.5299 20.2699 18.8199 18.1899 21.1099 14.5899C22.0099 13.1799 22.0099 10.8099 21.1099 9.39993C20.7799 8.87993 20.4199 8.38993 20.0499 7.92993\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.5099 12.7C15.2499 14.11 14.0999 15.26 12.6899 15.52\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9.47 14.53L2 22\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M21.9998 2L14.5298 9.47\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path>", 6)
const _hoisted_48 = [
  _hoisted_42
]
const _hoisted_49 = {
  key: 0,
  class: "field-error"
}
const _hoisted_50 = ["disabled"]
const _hoisted_51 = ["disabled"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "52",
    height: "52",
    viewBox: "0 0 52 52",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M40.1697 9.03505L28.2531 4.57172C27.0181 4.11672 25.0031 4.11672 23.7681 4.57172L11.8514 9.03505C9.55474 9.90172 7.69141 12.5884 7.69141 15.0367V32.5867C7.69141 34.3417 8.83974 36.6601 10.2481 37.7001L22.1647 46.6051C24.2664 48.1867 27.7114 48.1867 29.8131 46.6051L41.7297 37.7001C43.1381 36.6384 44.2864 34.3417 44.2864 32.5867V15.0367C44.3081 12.5884 42.4447 9.90172 40.1697 9.03505ZM27.6247 27.8851V33.5834C27.6247 34.4717 26.8881 35.2084 25.9997 35.2084C25.1114 35.2084 24.3747 34.4717 24.3747 33.5834V27.8851C22.1864 27.1917 20.5831 25.1551 20.5831 22.7501C20.5831 19.7601 23.0097 17.3334 25.9997 17.3334C28.9897 17.3334 31.4164 19.7601 31.4164 22.7501C31.4164 25.1767 29.8131 27.1917 27.6247 27.8851Z",
      fill: "#05CB95"
    })
  ]),
  /*#__PURE__*/_createElementVNode("h1", null, "Sucesso!!!"),
  /*#__PURE__*/_createElementVNode("h2", null, "Sua nova senha foi criada.")
], -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "52",
    height: "52",
    viewBox: "0 0 52 52",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M18.1787 40.0616V18.0482C18.1787 17.1816 18.4387 16.3366 18.9154 15.6216L24.8304 6.82491C25.762 5.41657 28.0804 4.41991 30.052 5.15657C32.1754 5.87157 33.5837 8.2549 33.1287 10.3782L32.002 17.4632C31.9154 18.1132 32.0887 18.6982 32.457 19.1532C32.8254 19.5649 33.367 19.8249 33.952 19.8249H42.857C44.5687 19.8249 46.042 20.5182 46.9087 21.7316C47.732 22.9016 47.8837 24.4182 47.342 25.9566L42.012 42.1849C41.3404 44.8716 38.4154 47.0599 35.512 47.0599H27.062C25.6104 47.0599 23.5737 46.5616 22.642 45.6299L19.8687 43.4849C18.807 42.6832 18.1787 41.4049 18.1787 40.0616Z",
      fill: "#05CB95"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11.288 13.8232H9.05634C5.69801 13.8232 4.33301 15.1232 4.33301 18.3299V40.1266C4.33301 43.3332 5.69801 44.6332 9.05634 44.6332H11.288C14.6463 44.6332 16.0113 43.3332 16.0113 40.1266V18.3299C16.0113 15.1232 14.6463 13.8232 11.288 13.8232Z",
      fill: "#05CB95"
    })
  ]),
  /*#__PURE__*/_createElementVNode("h1", null, "Muito bom!"),
  /*#__PURE__*/_createElementVNode("h2", null, "Suas alterações foram salvas.")
], -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "52",
  height: "52",
  viewBox: "0 0 52 52",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M42.2722 12.6747L29.4021 5.24301C27.3005 4.02967 24.7005 4.02967 22.5771 5.24301L9.72881 12.6747C7.62715 13.888 6.32715 16.1413 6.32715 18.5897V33.4097C6.32715 35.8363 7.62715 38.0897 9.72881 39.3247L22.5988 46.7563C24.7005 47.9697 27.3005 47.9697 29.4238 46.7563L42.2938 39.3247C44.3955 38.1113 45.6955 35.858 45.6955 33.4097V18.5897C45.6738 16.1413 44.3738 13.9097 42.2722 12.6747ZM24.3755 16.7913C24.3755 15.903 25.1121 15.1663 26.0005 15.1663C26.8888 15.1663 27.6255 15.903 27.6255 16.7913V28.1663C27.6255 29.0547 26.8888 29.7913 26.0005 29.7913C25.1121 29.7913 24.3755 29.0547 24.3755 28.1663V16.7913ZM27.9938 36.0313C27.8855 36.2913 27.7338 36.5297 27.5388 36.7463C27.1271 37.158 26.5855 37.3747 26.0005 37.3747C25.7188 37.3747 25.4371 37.3097 25.1771 37.2013C24.8955 37.093 24.6788 36.9413 24.4621 36.7463C24.2671 36.5297 24.1155 36.2913 23.9855 36.0313C23.8771 35.7713 23.8338 35.4897 23.8338 35.208C23.8338 34.6447 24.0505 34.0813 24.4621 33.6697C24.6788 33.4747 24.8955 33.323 25.1771 33.2147C25.9788 32.868 26.9321 33.063 27.5388 33.6697C27.7338 33.8863 27.8855 34.103 27.9938 34.3847C28.1021 34.6447 28.1671 34.9263 28.1671 35.208C28.1671 35.4897 28.1021 35.7713 27.9938 36.0313Z",
    fill: "#F19812"
  })
], -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("h1", null, "Cuidado!", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("h2", null, "Deseja mesmo deletar sua foto?", -1)
const _hoisted_57 = {
  key: 1,
  id: "profile-admin"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("p", null, "Perfil", -1)
const _hoisted_60 = [
  _hoisted_58,
  _hoisted_59
]
const _hoisted_61 = {
  key: 0,
  class: "data admin"
}
const _hoisted_62 = { class: "photo" }
const _hoisted_63 = {
  key: 0,
  class: "tooltip",
  for: "profile-photo"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = { key: 1 }
const _hoisted_67 = /*#__PURE__*/_createStaticVNode("<label class=\"tooltip\" for=\"profile-photo\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M13.2603 3.60022L5.05034 12.2902C4.74034 12.6202 4.44034 13.2702 4.38034 13.7202L4.01034 16.9602C3.88034 18.1302 4.72034 18.9302 5.88034 18.7302L9.10034 18.1802C9.55034 18.1002 10.1803 17.7702 10.4903 17.4302L18.7003 8.74022C20.1203 7.24022 20.7603 5.53022 18.5503 3.44022C16.3503 1.37022 14.6803 2.10022 13.2603 3.60022Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.8896 5.0498C12.3196 7.8098 14.5596 9.9198 17.3396 10.1998\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M3 22H21\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></label>", 1)
const _hoisted_68 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M18.8504 9.14014L18.2004 19.2101C18.0904 20.7801 18.0004 22.0001 15.2104 22.0001H8.79039C6.00039 22.0001 5.91039 20.7801 5.80039 19.2101L5.15039 9.14014\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10.3301 16.5H13.6601\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9.5 12.5H14.5\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 1)
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("p", null, "Adicione uma foto de perfil para sua área de trabalho ficar ainda mais personalizada.", -1)
const _hoisted_71 = { class: "form" }
const _hoisted_72 = { class: "sections" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("h1", null, "Dados do administrador", -1)
const _hoisted_74 = { class: "group" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nome"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", { for: "surname" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Sobrenome"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_77 = { class: "group" }
const _hoisted_78 = { for: "sector" }
const _hoisted_79 = ["onMousedown"]
const _hoisted_80 = { class: "sections" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("h1", null, "Dados de acesso", -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "E-mail"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_83 = { class: "sections" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("h1", null, "Nova senha", -1)
const _hoisted_85 = { class: "group" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", { for: "new-password" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Crie uma nova senha"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_87 = ["type"]
const _hoisted_88 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_89 = /*#__PURE__*/_createElementVNode("g", { id: "vuesax/linear/eye" }, [
  /*#__PURE__*/_createElementVNode("g", { id: "eye" }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector",
      d: "M15.58 11.9999C15.58 13.9799 13.98 15.5799 12 15.5799C10.02 15.5799 8.41998 13.9799 8.41998 11.9999C8.41998 10.0199 10.02 8.41992 12 8.41992C13.98 8.41992 15.58 10.0199 15.58 11.9999Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector_2",
      d: "M12 20.2702C15.53 20.2702 18.82 18.1902 21.11 14.5902C22.01 13.1802 22.01 10.8102 21.11 9.40021C18.82 5.80021 15.53 3.72021 12 3.72021C8.47003 3.72021 5.18003 5.80021 2.89003 9.40021C1.99003 10.8102 1.99003 13.1802 2.89003 14.5902C5.18003 18.1902 8.47003 20.2702 12 20.2702Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_90 = [
  _hoisted_89
]
const _hoisted_91 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_92 = /*#__PURE__*/_createStaticVNode("<path d=\"M14.5299 9.46992L9.46992 14.5299C8.81992 13.8799 8.41992 12.9899 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C12.9899 8.41992 13.8799 8.81992 14.5299 9.46992Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M17.8198 5.76998C16.0698 4.44998 14.0698 3.72998 11.9998 3.72998C8.46984 3.72998 5.17984 5.80998 2.88984 9.40998C1.98984 10.82 1.98984 13.19 2.88984 14.6C3.67984 15.84 4.59984 16.91 5.59984 17.77\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.41992 19.5299C9.55992 20.0099 10.7699 20.2699 11.9999 20.2699C15.5299 20.2699 18.8199 18.1899 21.1099 14.5899C22.0099 13.1799 22.0099 10.8099 21.1099 9.39993C20.7799 8.87993 20.4199 8.38993 20.0499 7.92993\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.5099 12.7C15.2499 14.11 14.0999 15.26 12.6899 15.52\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9.47 14.53L2 22\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M21.9998 2L14.5298 9.47\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path>", 6)
const _hoisted_98 = [
  _hoisted_92
]
const _hoisted_99 = /*#__PURE__*/_createElementVNode("label", { for: "confirm-new-password" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Senha"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_100 = ["type"]
const _hoisted_101 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_102 = /*#__PURE__*/_createElementVNode("g", { id: "vuesax/linear/eye" }, [
  /*#__PURE__*/_createElementVNode("g", { id: "eye" }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector",
      d: "M15.58 11.9999C15.58 13.9799 13.98 15.5799 12 15.5799C10.02 15.5799 8.41998 13.9799 8.41998 11.9999C8.41998 10.0199 10.02 8.41992 12 8.41992C13.98 8.41992 15.58 10.0199 15.58 11.9999Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "Vector_2",
      d: "M12 20.2702C15.53 20.2702 18.82 18.1902 21.11 14.5902C22.01 13.1802 22.01 10.8102 21.11 9.40021C18.82 5.80021 15.53 3.72021 12 3.72021C8.47003 3.72021 5.18003 5.80021 2.89003 9.40021C1.99003 10.8102 1.99003 13.1802 2.89003 14.5902C5.18003 18.1902 8.47003 20.2702 12 20.2702Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_103 = [
  _hoisted_102
]
const _hoisted_104 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_105 = /*#__PURE__*/_createStaticVNode("<path d=\"M14.5299 9.46992L9.46992 14.5299C8.81992 13.8799 8.41992 12.9899 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C12.9899 8.41992 13.8799 8.81992 14.5299 9.46992Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M17.8198 5.76998C16.0698 4.44998 14.0698 3.72998 11.9998 3.72998C8.46984 3.72998 5.17984 5.80998 2.88984 9.40998C1.98984 10.82 1.98984 13.19 2.88984 14.6C3.67984 15.84 4.59984 16.91 5.59984 17.77\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.41992 19.5299C9.55992 20.0099 10.7699 20.2699 11.9999 20.2699C15.5299 20.2699 18.8199 18.1899 21.1099 14.5899C22.0099 13.1799 22.0099 10.8099 21.1099 9.39993C20.7799 8.87993 20.4199 8.38993 20.0499 7.92993\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.5099 12.7C15.2499 14.11 14.0999 15.26 12.6899 15.52\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9.47 14.53L2 22\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M21.9998 2L14.5298 9.47\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path>", 6)
const _hoisted_111 = [
  _hoisted_105
]
const _hoisted_112 = {
  key: 0,
  class: "field-error"
}
const _hoisted_113 = ["disabled"]
const _hoisted_114 = {
  key: 1,
  class: "data org"
}
const _hoisted_115 = { class: "photo" }
const _hoisted_116 = {
  key: 0,
  class: "tooltip",
  for: "profile-photo"
}
const _hoisted_117 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_118 = [
  _hoisted_117
]
const _hoisted_119 = { key: 1 }
const _hoisted_120 = /*#__PURE__*/_createStaticVNode("<label class=\"tooltip\" for=\"profile-photo\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M13.2603 3.60022L5.05034 12.2902C4.74034 12.6202 4.44034 13.2702 4.38034 13.7202L4.01034 16.9602C3.88034 18.1302 4.72034 18.9302 5.88034 18.7302L9.10034 18.1802C9.55034 18.1002 10.1803 17.7702 10.4903 17.4302L18.7003 8.74022C20.1203 7.24022 20.7603 5.53022 18.5503 3.44022C16.3503 1.37022 14.6803 2.10022 13.2603 3.60022Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.8896 5.0498C12.3196 7.8098 14.5596 9.9198 17.3396 10.1998\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M3 22H21\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></label>", 1)
const _hoisted_121 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M18.8504 9.14014L18.2004 19.2101C18.0904 20.7801 18.0004 22.0001 15.2104 22.0001H8.79039C6.00039 22.0001 5.91039 20.7801 5.80039 19.2101L5.15039 9.14014\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10.3301 16.5H13.6601\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9.5 12.5H14.5\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 1)
const _hoisted_122 = [
  _hoisted_121
]
const _hoisted_123 = /*#__PURE__*/_createElementVNode("p", null, "Adicione a logo da sua organização para mostrar seu perfil personalizado.", -1)
const _hoisted_124 = { class: "form" }
const _hoisted_125 = { class: "sections" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("h1", null, "Dados da organização", -1)
const _hoisted_127 = /*#__PURE__*/_createElementVNode("label", { for: "tenant_name" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nome"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_128 = { class: "group" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("label", { for: "tenant_acronym" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Iniciais do nome"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("label", { for: "sectorActing" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Setor de atuação"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_131 = ["onMousedown"]
const _hoisted_132 = ["disabled"]

import { computed, onMounted, ref, watch } from 'vue'
import MyModal from '@/components/modal/MyModal.vue'
import { user, storageUrl } from '@/global/states/GlobalState'
import { useAxios } from '@/api/axios'
import { AxiosResponse } from 'axios'
import MySelectFilter from '@/components/select/MySelectFilter.vue'
import { OrganizationModel } from '@/models/OrganizationModel'
import { TenantModel } from '@/models/TenantModel'
import { toast } from 'vue3-toastify'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'
import { TenantSectorEnum, tenantSectorLabels } from '@/enums/Tenants/TenantSectorEnum'

/* Starts at the top of the page */

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {

window.scrollTo({
  top: 0,
  behavior: 'auto'
})

const isChamber = computed(() => user.value.tenant?.sector === TenantSectorEnum.CHAMBER)
const isLoading = ref(false)
const profilePayload = ref<{
  name?: string;
  email?: string;
  last_name?: string;
  image?: File | null;
  delete_image?: boolean;
  password: string;
  password_confirmation: string;
  organization_id?: number
}>({
  name: user.value.name,
  email: user.value.email,
  last_name: user.value.last_name,
  image: null,
  delete_image: false,
  password: '',
  password_confirmation: '',
  organization_id: user.value.organization_id
})

const passwordFeedback = computed(() => {
  const password = profilePayload.value.password
  const confirmation = profilePayload.value.password_confirmation

  if (!password) return ''
  if (password.length < 6) return 'A senha precisa ter pelo menos 6 caracteres.'
  if (!confirmation) return 'Confirme a nova senha.'
  if (password !== confirmation) return 'As senhas não coincidem.'
  return ''
})

const tenantPayload = ref<Partial<Pick<TenantModel, 'name' | 'acronym' | 'logo' | 'sector'>>>({
  name: user.value.tenant?.name,
  sector: user.value.tenant?.sector,
  acronym: user.value.tenant?.acronym,
  logo: undefined,
})

watch(() => user.value, () => {
  tenantPayload.value = {
    name: user.value.tenant!.name,
    sector: user.value.tenant!.sector,
    acronym: user.value.tenant!.acronym,
    logo: undefined,
  }

  sectorSearch.value = tenantSectorLabels[user.value.tenant!.sector]
  organizationSearch.value = user.value.organization!.name

  profilePayload.value = ({
    name: user.value.name,
    email: user.value.email,
    last_name: user.value.last_name,
    image: null,
    delete_image: false,
    password: '',
    password_confirmation: '',
    organization_id: user.value.organization_id
  })
})

const axios = useAxios()

function updateProfile () {
  const payload = new FormData()
  payload.append('_method', 'PATCH')
  payload.append('name', profilePayload.value.name as string)
  payload.append('email', profilePayload.value.email as string)
  payload.append('last_name', profilePayload.value.last_name as string)
  if ((user.value!.hasRoles!(['Super Admin']) || user.value!.hasRoles!(['Presidente'])) && profilePayload.value.organization_id) {
    payload.append('organization_id', String(profilePayload.value.organization_id))
  }
  payload.append('delete_image', (profilePayload.value.delete_image ? '1' : '0'))
  if (profilePayload.value.image) {
    payload.append('image', profilePayload.value.image as File)
  }
  const isChangingPassword = !!profilePayload.value.password
  if (isChangingPassword) {
    payload.append('password', profilePayload.value.password)
  }

  isLoading.value = true

  axios.post('/api/profile', payload).then((res: AxiosResponse) => {
    user.value = { ...user.value, ...res.data.user }
    profilePayload.value.password = ''
    profilePayload.value.password_confirmation = ''

    if (isChangingPassword) {
      isNewPasswordCreateModal.value = true
    } else {
      isConfirmUpdateDataProfileModal.value = true
    }

    toast.success(isChangingPassword ? 'Senha atualizada com sucesso' : 'Perfil atualizado com sucesso')
  })
  .finally(() => isLoading.value = false)
}

function updateTenant () {
  isLoading.value = true

  axios.patch('/api/tenants', tenantPayload.value)
    .then(() => {
      toast.success('Organização atualizada com sucesso')
    })
    .finally(() => isLoading.value = false)
}

function getOrganizations () {
  axios.get('/api/organizations')
    .then((res) => {
      organizations.value = res.data
    })
}

const tab = ref<'admin' | 'org'>('admin')

/* Select Sector */
const organizationSearch = ref<string>(user.value.organization?.name ?? '')
const organizations = ref<OrganizationModel[]>([])

const filteredOrganizations = computed(() => {
    return organizations.value?.filter(
      Sector =>
        Sector.name.toLowerCase().includes(organizationSearch.value?.toLowerCase())
    )
})

const verifyValueSector = (value: string) => {
  if (organizations.value) {
    let onClear = false
    for (const [index, options] of organizations.value.entries()) {
      if (options.name == value) {
        onClear = true
      }
    }
    if (!onClear) {
      organizationSearch.value = ''
      profilePayload.value.organization_id = undefined
    }
  }
}

/* Select Sector Acting */
const sectorSearch = ref(user.value.tenant ? tenantSectorLabels[user.value.tenant?.sector] : '')
const sectors = ref<{ value: TenantSectorEnum, label: string }[]>([
  { value: TenantSectorEnum.PUBLIC, label: tenantSectorLabels[TenantSectorEnum.PUBLIC] },
  { value: TenantSectorEnum.PRIVATE, label: tenantSectorLabels[TenantSectorEnum.PRIVATE] },
  { value: TenantSectorEnum.CHAMBER, label: tenantSectorLabels[TenantSectorEnum.CHAMBER] },
])

const filteredSectors = computed(() => {
    return sectors.value?.filter(
      Sector =>
        Sector.label.toLowerCase().includes(sectorSearch.value?.toLowerCase())
    )
})

const verifySector = (value: string) => {
  if (sectors.value) {
    let onClear = false
    for (const [index, options] of sectors.value.entries()) {
      if (options.label == value) {
        onClear = true
      }
    }
    if (!onClear) {
      sectorSearch.value = ''
      tenantPayload.value.sector = undefined
    }
  }
}

/* Select State */
const selectedState = ref<any>()
const documentStateSearch = ref('')
const documentStatesInitial = ref<any[]>([
  { name: 'Estado' }
])

const documentStates = computed(() => {
    return documentStatesInitial.value?.filter(
      Sector =>
        Sector.name.toLowerCase().includes(documentStateSearch.value.toLowerCase())
    )
})

const verifyValueState = (value: string) => {
  if (documentStatesInitial.value) {
    let onClear = false
    for (const [index, options] of documentStatesInitial.value.entries()) {
      if (options.name == value) {
        onClear = true
      }
    }
    if (!onClear) {
      documentStateSearch.value = ''
      selectedState.value = undefined
    }
  }
}

/* Select City */
const selectedCity = ref<any>()
const documentCitySearch = ref('')
const documentCitysInitial = ref<any[]>([
  {name: 'Cidade'}
])

const documentCitys = computed(() => {
    return documentCitysInitial.value?.filter(
      Sector =>
        Sector.name.toLowerCase().includes(documentCitySearch.value.toLowerCase())
    )
})

const verifyValueCity = (value: string) => {
  if (documentCitysInitial.value) {
    let onClear = false
    for (const [index, options] of documentCitysInitial.value.entries()) {
      if (options.name == value) {
        onClear = true
      }
    }
    if (!onClear) {
      documentCitySearch.value = ''
      selectedCity.value = undefined
    }
  }
}

/* Visibility variables for password fields. */
const showPassword = ref<boolean>(false)
const showNewPassword = ref<boolean>(false)
const showRepeatNewPassword = ref<boolean>(false)

/* Alert modal variables. */
const isNewPasswordCreateModal = ref<boolean>(false)
const isConfirmUpdateDataProfileModal = ref<boolean>(false)
const isConfirmDeletePhotoModal = ref<boolean>(false)

/* Cariable with the user photo image. */
const profileImagePreview = ref<string>('')
const tenantLogoPreview = ref<string>('')

/* Change the value of the image item. */
const handleProfileImageChange = (event: Event) => {
  const input = event.target as HTMLInputElement
  const file: File | null = input.files && input.files[0]
  profilePayload.value.image = file
  if (file) {
    profilePayload.value.delete_image = false
    const reader = new FileReader()
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        profileImagePreview.value = reader.result
      }
    }
    reader.readAsDataURL(file)
  }
}

const handleTenantLogoChange = (event: Event) => {
  const input = event.target as HTMLInputElement
  const file: File | null = input.files && input.files[0]
  tenantPayload.value.logo = file!
  tenantLogoPreview.value = URL.createObjectURL(file!)
}

onMounted(() => {
  getOrganizations()
})

return (_ctx: any,_cache: any) => {
  return (!!_unref(user).id && !(_unref(user).hasRoles!(['Super Admin'])) && !(_unref(user).hasRoles!(['Presidente'])))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/admin/home'))),
          class: "back"
        }, _hoisted_4),
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("main", null, [
          _hoisted_7,
          _createElementVNode("form", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", {
                class: _normalizeClass(["data", { 'nophoto': profileImagePreview.value == '' && !_unref(user).image}])
              }, [
                _createElementVNode("div", {
                  style: _normalizeStyle({ backgroundImage: 'url(' + (profileImagePreview.value ? profileImagePreview.value : profilePayload.value.delete_image ? '' : (_unref(storageUrl) + _unref(user).image)) + ')' })
                }, [
                  (profileImagePreview.value == '' && !_unref(user).image)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_11, _hoisted_13))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("label", {
                          class: "tooltip",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (isConfirmDeletePhotoModal.value = true))
                        }, _hoisted_17)
                      ]))
                ], 4),
                _createElementVNode("input", {
                  autocomplete: "off",
                  type: "file",
                  name: "profile-photo",
                  id: "profile-photo",
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (handleProfileImageChange($event)))
                }, null, 32),
                _hoisted_18
              ], 2)
            ]),
            _createElementVNode("section", null, [
              _hoisted_19,
              _withDirectives(_createElementVNode("input", {
                autocomplete: "off",
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((profilePayload.value.name) = $event)),
                name: "name",
                id: "name"
              }, null, 512), [
                [_vModelText, profilePayload.value.name]
              ])
            ]),
            _createElementVNode("section", null, [
              _hoisted_20,
              _withDirectives(_createElementVNode("input", {
                autocomplete: "off",
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((profilePayload.value.last_name) = $event)),
                name: "last_name",
                id: "surname"
              }, null, 512), [
                [_vModelText, profilePayload.value.last_name]
              ])
            ]),
            _createElementVNode("section", null, [
              _hoisted_21,
              _withDirectives(_createElementVNode("input", {
                autocomplete: "off",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((profilePayload.value.email) = $event)),
                type: "text",
                name: "email",
                id: "email"
              }, null, 512), [
                [_vModelText, profilePayload.value.email]
              ])
            ])
          ]),
          _createElementVNode("form", _hoisted_22, [
            _createElementVNode("section", null, [
              _hoisted_23,
              _withDirectives(_createElementVNode("input", {
                autocomplete: "new-password",
                placeholder: "Com pelo menos 6 caractes",
                type: showNewPassword.value ? 'text':'password',
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((profilePayload.value.password) = $event)),
                name: "new-password",
                id: "new-password"
              }, null, 8, _hoisted_24), [
                [_vModelDynamic, profilePayload.value.password]
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (showNewPassword.value = !showNewPassword.value))
              }, [
                (showNewPassword.value)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_25, _hoisted_27))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_28, _hoisted_35))
              ])
            ]),
            _createElementVNode("section", null, [
              _hoisted_36,
              _withDirectives(_createElementVNode("input", {
                autocomplete: "new-password",
                placeholder: "A mesma do campo anterior",
                type: showRepeatNewPassword.value ? 'text':'password',
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((profilePayload.value.password_confirmation) = $event)),
                name: "repeat-new-password",
                id: "repeat-new-password"
              }, null, 8, _hoisted_37), [
                [_vModelDynamic, profilePayload.value.password_confirmation]
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (showRepeatNewPassword.value = !showRepeatNewPassword.value))
              }, [
                (showRepeatNewPassword.value)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_38, _hoisted_40))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_41, _hoisted_48))
              ])
            ]),
            (passwordFeedback.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_49, _toDisplayString(passwordFeedback.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("nav", null, [
            (!isLoading.value)
              ? (_openBlock(), _createElementBlock("input", {
                  key: 0,
                  autocomplete: "off",
                  onClick: updateProfile,
                  disabled: !profilePayload.value.name || !profilePayload.value.last_name || !profilePayload.value.email,
                  type: "button",
                  id: "profile-update-infos",
                  value: "Salvar alterações"
                }, null, 8, _hoisted_50))
              : _createCommentVNode("", true),
            (!isLoading.value)
              ? (_openBlock(), _createElementBlock("input", {
                  key: 1,
                  autocomplete: "off",
                  onClick: updateProfile,
                  disabled: !profilePayload.value.password || profilePayload.value.password !== profilePayload.value.password_confirmation || profilePayload.value.password.length < 6,
                  type: "button",
                  id: "profile-update-password",
                  value: "Salvar alterações"
                }, null, 8, _hoisted_51))
              : _createCommentVNode("", true),
            (isLoading.value)
              ? (_openBlock(), _createBlock(SpinnerLoaderButton, {
                  key: 2,
                  height: 60,
                  maxWidth: 350
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(MyModal, {
          width: '330px !important',
          height: '179px !important',
          isOpen: isNewPasswordCreateModal.value,
          "class-name": 'new-password-create',
          toggleModal: (v) => isNewPasswordCreateModal.value = v,
          zIndex: 100
        }, {
          default: _withCtx(() => [
            _hoisted_52
          ]),
          _: 1
        }, 8, ["isOpen", "toggleModal"]),
        _createVNode(MyModal, {
          width: '330px !important',
          height: '179px !important',
          isOpen: isConfirmUpdateDataProfileModal.value,
          "class-name": 'confirm-update-data-profile',
          toggleModal: (v) => isConfirmUpdateDataProfileModal.value = v,
          zIndex: 100
        }, {
          default: _withCtx(() => [
            _hoisted_53
          ]),
          _: 1
        }, 8, ["isOpen", "toggleModal"]),
        _createVNode(MyModal, {
          width: '330px !important',
          height: '260px !important',
          isOpen: isConfirmDeletePhotoModal.value,
          "class-name": 'confirm-delete-photo',
          toggleModal: (v) => isConfirmDeletePhotoModal.value = v,
          zIndex: 100
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _hoisted_54,
              _hoisted_55,
              _hoisted_56,
              _createElementVNode("section", null, [
                _createElementVNode("button", {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => {isConfirmDeletePhotoModal.value = false; profileImagePreview.value = ''; profilePayload.value.delete_image = true;})
                }, "Sim"),
                _createElementVNode("input", {
                  autocomplete: "off",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => {isConfirmDeletePhotoModal.value = false;}),
                  type: "button",
                  value: "Cancelar"
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["isOpen", "toggleModal"])
      ]))
    : (_unref(user).name)
      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
          _createElementVNode("label", {
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$router.push('/admin/home'))),
            class: "back"
          }, _hoisted_60),
          _createElementVNode("div", {
            class: _normalizeClass(['tab', tab.value])
          }, [
            _createElementVNode("h1", {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (tab.value = 'admin'))
            }, "Administrador"),
            _createElementVNode("h1", {
              onClick: _cache[14] || (_cache[14] = ($event: any) => (tab.value = 'org'))
            }, "Organização")
          ], 2),
          (tab.value == 'admin')
            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                _createElementVNode("section", _hoisted_62, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["data", { 'nophoto': profileImagePreview.value == '' && !_unref(user).image}])
                  }, [
                    _createElementVNode("div", {
                      style: _normalizeStyle({ backgroundImage: 'url(' + (profileImagePreview.value ? profileImagePreview.value : profilePayload.value.delete_image ? '' : (_unref(storageUrl) + _unref(user).image)) + ')' })
                    }, [
                      (profileImagePreview.value == '' && !_unref(user).image)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_63, _hoisted_65))
                        : (_openBlock(), _createElementBlock("div", _hoisted_66, [
                            _hoisted_67,
                            _createElementVNode("label", {
                              class: "tooltip",
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (isConfirmDeletePhotoModal.value = true))
                            }, _hoisted_69)
                          ]))
                    ], 4),
                    _createElementVNode("input", {
                      autocomplete: "off",
                      type: "file",
                      name: "profile-photo",
                      id: "profile-photo",
                      onChange: _cache[16] || (_cache[16] = ($event: any) => (handleProfileImageChange($event)))
                    }, null, 32),
                    _hoisted_70
                  ], 2)
                ]),
                _createElementVNode("form", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _hoisted_73,
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("section", null, [
                        _hoisted_75,
                        _withDirectives(_createElementVNode("input", {
                          autocomplete: "off",
                          type: "text",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((profilePayload.value.name) = $event)),
                          name: "name",
                          id: "name"
                        }, null, 512), [
                          [_vModelText, profilePayload.value.name]
                        ])
                      ]),
                      _createElementVNode("section", null, [
                        _hoisted_76,
                        _withDirectives(_createElementVNode("input", {
                          autocomplete: "off",
                          type: "text",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((profilePayload.value.last_name) = $event)),
                          name: "last_name",
                          id: "surname"
                        }, null, 512), [
                          [_vModelText, profilePayload.value.last_name]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("section", null, [
                        _createElementVNode("label", _hoisted_78, [
                          _createElementVNode("strong", null, _toDisplayString(isChamber.value ? 'Sua câmara atual' : 'Seu setor atual'), 1),
                          _createTextVNode(" (obrigatório)")
                        ]),
                        _createVNode(MySelectFilter, {
                          name: 'sector',
                          value: organizationSearch.value,
                          modelValue: organizationSearch.value,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((organizationSearch).value = $event)),
                          onBlur: verifyValueSector
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOrganizations.value, (sector, index) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: index,
                                onMousedown: ($event: any) => {profilePayload.value.organization_id = sector.id; organizationSearch.value = sector.name;}
                              }, _toDisplayString(sector.name), 41, _hoisted_79))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value", "modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    _hoisted_81,
                    _createElementVNode("section", null, [
                      _hoisted_82,
                      _withDirectives(_createElementVNode("input", {
                        autocomplete: "off",
                        type: "text",
                        name: "email",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((profilePayload.value.email) = $event)),
                        id: "email"
                      }, null, 512), [
                        [_vModelText, profilePayload.value.email]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_83, [
                    _hoisted_84,
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("section", null, [
                        _hoisted_86,
                        _withDirectives(_createElementVNode("input", {
                          autocomplete: "new-password",
                          placeholder: "Pelo menos 6 caracteres",
                          type: showNewPassword.value ? 'text':'password',
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((profilePayload.value.password) = $event)),
                          name: "new-password",
                          id: "new-password"
                        }, null, 8, _hoisted_87), [
                          [_vModelDynamic, profilePayload.value.password]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (showNewPassword.value = !showNewPassword.value))
                        }, [
                          (showNewPassword.value)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_88, _hoisted_90))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_91, _hoisted_98))
                        ])
                      ]),
                      _createElementVNode("section", null, [
                        _hoisted_99,
                        _withDirectives(_createElementVNode("input", {
                          autocomplete: "new-password",
                          placeholder: "Igual a digitada do campo anterior",
                          type: showRepeatNewPassword.value ? 'text':'password',
                          name: "confirm-new-password",
                          id: "confirm-new-password",
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((profilePayload.value.password_confirmation) = $event))
                        }, null, 8, _hoisted_100), [
                          [_vModelDynamic, profilePayload.value.password_confirmation]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (showRepeatNewPassword.value = !showRepeatNewPassword.value))
                        }, [
                          (showRepeatNewPassword.value)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_101, _hoisted_103))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_104, _hoisted_111))
                        ])
                      ])
                    ]),
                    (passwordFeedback.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_112, _toDisplayString(passwordFeedback.value), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("nav", null, [
                    (!isLoading.value)
                      ? (_openBlock(), _createElementBlock("input", {
                          key: 0,
                          autocomplete: "off",
                          type: "button",
                          id: "profile-update-password",
                          value: "Salvar alterações",
                          onClick: updateProfile,
                          disabled: !profilePayload.value.name || !profilePayload.value.last_name || !profilePayload.value.email || (!!profilePayload.value.password && (profilePayload.value.password !== profilePayload.value.password_confirmation || profilePayload.value.password.length < 6))
                        }, null, 8, _hoisted_113))
                      : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                          key: 1,
                          height: 60,
                          maxWidth: 345
                        }))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_114, [
                _createElementVNode("section", _hoisted_115, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["data", { 'nophoto': tenantLogoPreview.value == '' && !_unref(user).tenant?.logo}])
                  }, [
                    _createElementVNode("div", {
                      style: _normalizeStyle({ backgroundImage: 'url(' + (tenantLogoPreview.value ? tenantLogoPreview.value : profilePayload.value.delete_image ? '' : (_unref(storageUrl) + _unref(user).tenant?.logo)) + ')' })
                    }, [
                      (tenantLogoPreview.value == '' && !_unref(user).tenant?.logo)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_116, _hoisted_118))
                        : (_openBlock(), _createElementBlock("div", _hoisted_119, [
                            _hoisted_120,
                            _createElementVNode("label", {
                              class: "tooltip",
                              onClick: _cache[25] || (_cache[25] = ($event: any) => (isConfirmDeletePhotoModal.value = true))
                            }, _hoisted_122)
                          ]))
                    ], 4),
                    _createElementVNode("input", {
                      autocomplete: "off",
                      type: "file",
                      name: "profile-photo",
                      id: "profile-photo",
                      onChange: _cache[26] || (_cache[26] = ($event: any) => (handleTenantLogoChange($event)))
                    }, null, 32),
                    _hoisted_123
                  ], 2)
                ]),
                _createElementVNode("form", _hoisted_124, [
                  _createElementVNode("div", _hoisted_125, [
                    _hoisted_126,
                    _createElementVNode("section", null, [
                      _hoisted_127,
                      _withDirectives(_createElementVNode("input", {
                        autocomplete: "off",
                        type: "text",
                        name: "tenant_name",
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((tenantPayload.value.name) = $event)),
                        id: "tenant_name"
                      }, null, 512), [
                        [_vModelText, tenantPayload.value.name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_128, [
                      _createElementVNode("section", null, [
                        _hoisted_129,
                        _withDirectives(_createElementVNode("input", {
                          autocomplete: "off",
                          type: "text",
                          name: "tenant_acronym",
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((tenantPayload.value.acronym) = $event)),
                          id: "tenant_acronym"
                        }, null, 512), [
                          [_vModelText, tenantPayload.value.acronym]
                        ])
                      ]),
                      _createElementVNode("section", null, [
                        _hoisted_130,
                        _createVNode(MySelectFilter, {
                          name: 'sectorActing',
                          value: sectorSearch.value,
                          modelValue: sectorSearch.value,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((sectorSearch).value = $event)),
                          onBlur: verifySector
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSectors.value, (sector, index) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: index,
                                onMousedown: ($event: any) => {tenantPayload.value.sector = sector.value; sectorSearch.value = sector.label;}
                              }, _toDisplayString(sector.label), 41, _hoisted_131))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value", "modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("nav", null, [
                    (!isLoading.value)
                      ? (_openBlock(), _createElementBlock("input", {
                          key: 0,
                          autocomplete: "off",
                          type: "button",
                          id: "profile-update-password",
                          value: "Salvar alterações",
                          onClick: updateTenant,
                          disabled: !tenantPayload.value.name || !tenantPayload.value.acronym
                        }, null, 8, _hoisted_132))
                      : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                          key: 1,
                          height: 60,
                          maxWidth: 345
                        }))
                  ])
                ])
              ]))
        ]))
      : _createCommentVNode("", true)
}
}

})